module.exports = __webpack_public_path__ + "img/fr.831bacef.png";